import { useReducer, useMemo, createContext, useContext } from "react"
import { setAuthLocal, removeAuthLocal, getAuthLocal } from "../../../lib/localstorage"
import KEY from "./Const"

function initialState() {
  const auth = getAuthLocal()
  return auth && Object.keys(auth).length ? auth : {}
}

function reducer(state, action) {
  switch (action.type) {
    case KEY.SET_AUTH:
      return { ...state, ...action.value }
    case KEY.LOG_OUT:
      removeAuthLocal()
      return {}
    default:
      return state
  }
}

const MyContext = createContext(initialState())
MyContext.displayName = "MyContext"

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState())

  const setAuth = (value) => {
    const next = { ...state, ...value }
    setAuthLocal(next)
    return dispatch({ type: KEY.SET_AUTH, value })
  }

  const logOut = () => dispatch({ type: KEY.LOG_OUT })

  const value = useMemo(
    () => ({
      ...state,
      setAuth,
      logOut
    }),
    [state]
  )
  return <MyContext.Provider value={value} {...props} />
}

const useStore = () => {
  const context = useContext(MyContext)
  if (context === undefined) {
    throw new Error("useStore must be used within StoreProvider")
  }
  return context
}

export default useStore
